"use client"

import React from "react"
import { BaseFormElementProps } from "../../utils"
import { TTextarea } from "./TTextarea"

/**
 * @deprecated TTextarea의 autoSize prop을 사용하세요.
 * ```tsx
 * // Before
 * <TTextareaAutoSize value={text} minRows={2} maxRows={8} onChange={setText} />
 *
 * // After
 * <TTextarea value={text} autoSize={{ minRows: 2, maxRows: 8 }} onChange={setText} />
 * ```
 */
interface TTextareaAutoSizeProps extends BaseFormElementProps {
	value?: string
	placeholder?: string
	warning?: boolean
	minRows?: number
	maxRows?: number
	autoFocus?: boolean
	autoComplete?: string
	spellCheck?: boolean
	disabledEnterKey?: boolean
	renderInnerContent?: React.ReactNode
	onChange?: (value: string) => void
	onFocus?: () => void
	onBlur?: () => void
	onSelect?: () => void
	onEnterKey?: (value: string) => void
}

/**
 * @deprecated TTextarea의 autoSize prop을 사용하세요.
 * @example <TTextarea value={text} autoSize={{ minRows: 2, maxRows: 8 }} onChange={setText} />
 */
export const TTextareaAutoSize = React.memo(
	React.forwardRef<HTMLTextAreaElement, TTextareaAutoSizeProps>((props, ref) => {
		const {
			minRows,
			maxRows,
			id,
			className,
			value,
			placeholder,
			required,
			disabled,
			readOnly,
			error,
			warning,
			autoFocus,
			autoComplete,
			spellCheck,
			disabledEnterKey,
			renderInnerContent,
			dataAttributes,
			onChange,
			onFocus,
			onBlur,
			onSelect,
			onEnterKey
		} = props

		return (
			<TTextarea
				ref={ref}
				id={id}
				className={className}
				value={value}
				placeholder={placeholder}
				required={required}
				disabled={disabled}
				readOnly={readOnly}
				error={error}
				warning={warning}
				autoFocus={autoFocus}
				autoComplete={autoComplete}
				spellCheck={spellCheck}
				disabledEnterKey={disabledEnterKey}
				renderInnerContent={renderInnerContent}
				dataAttributes={dataAttributes}
				autoSize={{ minRows: minRows ?? 1, maxRows }}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
				onSelect={onSelect}
				onEnterKey={onEnterKey}
			/>
		)
	})
)

TTextareaAutoSize.displayName = "TTextareaAutoSize"
